// extracted by mini-css-extract-plugin
export var displayNone = "_n7-6";
export var imgContainer = "_n7-2";
export var overflowHidden = "_n7-3";
export var productInfoCardButtonContainer = "_n7-5";
export var productTitleText = "_n7-4";
export var rightArrow = "_n7-1";
export var rightArrowContainer = "_n7-0";